module.exports = __webpack_public_path__ + "NoCollateral-0355e2af.webp";